import React from 'react';
import OptionsList from '../../OptionsList';
import ChatMessageBubble from '../../ChatMessageBubble';

interface ChatIntentOptionsProps {
  message: {
    text: string;
    i18n: string;
    smartFormStyle?: boolean;
    metadata: {
      intents: React.ComponentProps<typeof OptionsList>['options'];
    };
    type: any;
    createdAt: any;
  };
  languageCode: string;
  showOptions: boolean;
  handleSelection: React.ComponentProps<typeof OptionsList>['onSelection'];
  readOnly?: boolean;
}

const ChatIntentOptions = function ({
  handleSelection,
  languageCode,
  message,
  showOptions,
  readOnly = false,
}: ChatIntentOptionsProps) {
  return (
    <ChatMessageBubble>
      <OptionsList
        message={message.text || message.i18n}
        options={message.metadata.intents}
        onSelection={handleSelection}
        showOptionChildren={false}
        languageCode={languageCode}
        showOptions={showOptions}
        readOnly={readOnly}
      />
    </ChatMessageBubble>
  );
};

export default ChatIntentOptions;
